import {
  ACQUIRE_LOCK_FOR_ENTITY_REQUEST, ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED, ACQUIRING_LOCK_FOR_ENTITY_FAILED, 
  RELEASE_LOCK_FOR_ENTITY_REQUEST, RELEASING_LOCK_FOR_ENTITY_SUCCEDDED, RELEASING_LOCK_FOR_ENTITY_FAILED, BREAK_LOCK_FOR_ENTITY_REQUEST, BREAKING_LOCK_FOR_ENTITY_SUCCEDDED, BREAKING_LOCK_FOR_ENTITY_FAILED, WS_ENTITY_LOCK_BROKEN, INVALIDATE_LOCK_STATE,
} from 'constants/actionTypes';

import _ from 'lodash';
import LockService from 'services/lock.service';

const initialState = {
  acquiring: false,
  items: []
}

export function lockReducer(state = initialState, action) {
  switch (action.type) {
    case ACQUIRE_LOCK_FOR_ENTITY_REQUEST: {
      const { reference } = action.payload;
    
      const id = `${reference.type}_${reference.id}`;

      return {
        ...state,
        [id]: {
          acquiring: true,
          acquired: false,
          item: null,
        }
      }
    }

    case ACQUIRING_LOCK_FOR_ENTITY_SUCCEDDED: {
      const { reference, response } = action.payload;
    
      const id = `${reference.type}_${reference.id}`;

      return {
        ...state,
        [id]: {
          acquiring: false,
          acquired: true,
          item: response,
        }
      }
    }

    case ACQUIRING_LOCK_FOR_ENTITY_FAILED: {
      const { reference, error } = action.payload;
    
      const id = `${reference.type}_${reference.id}`;
      const lock = _.get(error, 'errors.[0].lock', null);

      return {
        ...state,
        [id]: {
          acquiring: false,
          acquired: false,
          item: lock,
          error: error,
          lockLost: true
        }
      }
    }

    case RELEASE_LOCK_FOR_ENTITY_REQUEST: {
      const { reference } = action.payload;
    
      const id = LockService.getId(reference);
      const lockState = state[id];
      
      if(!lockState){
        return state;
      }

      return {
        ...state,
        [id]: {
          ...lockState,
          releasing: true,
          released: false,
        }
      }
    }

    case RELEASING_LOCK_FOR_ENTITY_SUCCEDDED: {
      const { reference } = action.payload;
    
      const id = LockService.getId(reference);
      const lockState = state[id];
      
      if(!lockState){
        return state;
      }

      return {
        ...state,
        [id]: {
          ...lockState,
          releasing: false,
          released: true,
        }
      }
    }

    case RELEASING_LOCK_FOR_ENTITY_FAILED: {
      const { reference, error } = action.payload;
    
      const id = LockService.getId(reference);
      const lockState = state[id];

      return {
        ...state,
        [id]: {
          ...lockState,
          releasing: false,
          released: false,
          error: error,
        }
      }
    }

    case BREAK_LOCK_FOR_ENTITY_REQUEST: {
      const { reference } = action.payload;
    
      const id = LockService.getId(reference);
      const lockState = state[id] || {};
    
      return {
        ...state,
        [id]: {
          ...lockState,
          breaking: true,
          broken: false,
        }
      }
    }

    case BREAKING_LOCK_FOR_ENTITY_SUCCEDDED: {
      const { reference } = action.payload;
    
      const id = LockService.getId(reference);
      const lockState = state[id] || {};
      
      return {
        ...state,
        [id]: {
          ...lockState,
          breaking: false,
          broken: true,
        }
      }
    }

    case BREAKING_LOCK_FOR_ENTITY_FAILED: {
      const { reference, error } = action.payload;
    
      const id = LockService.getId(reference);
      const lockState = state[id] || {};

      return {
        ...state,
        [id]: {
          ...lockState,
          breaking: false,
          broken: false,
          error: error,
        }
      }
    }

    case INVALIDATE_LOCK_STATE: {
      const { reference } = action.payload;
    
      const id = LockService.getId(reference);
      const lockState = _.omit(state, id);

      return lockState;
    }    

    case WS_ENTITY_LOCK_BROKEN: {
      const { parentReference, token } = action.payload;
    
      const id = LockService.getId(parentReference);
      const lockState = state[id];

      if(!lockState){
        return state;
      }


      const lockstateToken = _.get(lockState, 'item.token', '');

      if(lockstateToken !== token){
        return state;
      }

      return {
        ...state,
        [id]: {
          ...lockState,
          lockLost: true,
        }
      }
    }    

    default:
      return state
  }
}